// extracted by mini-css-extract-plugin
export default {"wrapper":"main-10_wrapper__aA3LL","container":"main-10_container__rRXcN","boxText":"main-10_boxText__lahn1","boxBtn":"main-10_boxBtn__RVIdB"};